export default __webpack_public_path__ + "static/media/send_message.128181f8.png";